import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AslibModalComponent } from '@aslib/modal';
import { Subscription } from 'rxjs/Subscription';
import { BaseComponentService } from '../../services/base-component.service';
import { ProjetoComponent } from './projeto.component';


@Component({
  selector: 'gpa-modal-projeto',
  templateUrl: './modal-projeto.component.html',
  providers: [BaseComponentService]
})

export class ModalProjetoComponent extends BaseComponentService implements OnInit {

  @Input() modoEdicao: boolean;


  projetos: any[];
  projeto: any;

  ngOnInit() {
    this.projetos = [];
    this.projeto = '';
    this.preencheCombo('/api/InformacaoProjeto/ObterProjetosGeracaoAutomatico/0', 'projetos', 'siad');
  }

  salvarOnClick(codProjeto: string){
    this._service.routePrefix = '/api/InformacaoProjeto/GeracaoPagamentoAutomatico'.concat(`/${codProjeto.replace(/\s/g, '')}/1`);
    this.aslibLoadingService.start();
      this.subSave = this._service.getAll('siad').subscribe(data => {
          ProjetoComponent.updateList.next(data);
          this.exibirSucesso('Projeto salvo com sucesso.');
        },
        erro => {
          this.exibirErro(erro);
        },
        () => {
          this.aslibLoadingService.complete();
        }
      );
  }

  cancelarOnClick(){
    ProjetoComponent.updateList.next('');
  }

}



// WEBPACK FOOTER //
// ./src/app/controle-dados/projeto/modal-projeto.component.ts